<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Fill In The Blank</h1>
      <div class="text-large">I love {{CompanyName}} because _________.</div>
    </div>
  </div>
<Posts Category="fill-in-the-blank" />


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  data() {
    return {
    CompanyName: process.env.VUE_APP_COMPANY_NAME
  }
  },
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
